import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import App from './App';
import GalleryPage from './GalleryPage';
import About from './About';
import Contact from './Contact';
import SplashScreen from './SplashScreen';
import InstallPwaPrompt from './InstallPwaPrompt';

export default function Root() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <BrowserRouter>
      {showSplash && <SplashScreen onClose={() => setShowSplash(false)} />}
      <InstallPwaPrompt />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}
